import { useState } from 'react';
import chatSvg from '../../../../assets/images/svgs/chat.svg';
import imageSvg from '../../../../assets/images/svgs/image.svg';
import sendSvg from '../../../../assets/images/svgs/arrow-top-black.svg';
import Button from '../../../../components/primitives/button';
import { displayName } from '../../application/mapChat';
import type { ChatRoomSummary } from '../../application/types';
import { useChatMessages } from '../hooks/useChatMessages';

export type ChatThreadProps = {
  selectedRoom: ChatRoomSummary | null;
};

export function ChatThread({ selectedRoom }: ChatThreadProps) {
  const { messages, send, currentUserId, isSending } =
    useChatMessages(selectedRoom);
  const [draft, setDraft] = useState('');

  const handleSend = async () => {
    const body = draft.trim();
    if (!body || isSending) {
      return;
    }
    await send(body);
    setDraft('');
  };

  if (!selectedRoom) {
    return (
      <div className="chat">
        <div className="basic-chat">
          <img src={chatSvg} className="chat-svg" alt="" />
        </div>
      </div>
    );
  }

  return (
    <div className="chat">
      <div className="current-chat">
        <div className="current-chat__header">
          <p className="current-chat__header-name">
            {displayName(selectedRoom.peer)}
          </p>
        </div>
        <div className="current-chat__messages">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`message ${
                msg.ownerId === currentUserId ? 'sent' : 'received'
              }`}
            >
              <p>{msg.body}</p>
              <span className="timestamp">
                {msg.createdAt
                  ? new Date(msg.createdAt).toLocaleTimeString()
                  : ''}
              </span>
            </div>
          ))}
        </div>
        <div className="current-chat__input">
          <Button
            onClick={() => {}}
            className="non-border-btn"
            iconSvg={<img src={imageSvg} alt="" />}
            buttonHeight="32px"
          />
          <input
            type="text"
            name="message"
            placeholder="Enter your message..."
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                void handleSend();
              }
            }}
          />
          <Button
            onClick={() => {
              void handleSend();
            }}
            className="circle-border-btn"
            iconSvg={<img src={sendSvg} alt="" />}
          />
        </div>
      </div>
    </div>
  );
}

export default ChatThread;
